import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import OrderItem from "../../entity/emergency/OrderItem";
import useEmergencyInterventionDemo
    from "../../component/private/intervention/emergency/demo/useEmergencyInterventionDemoServer";

const SERVICE = "service-emergency";
const ENTITY = "order_items";

/**
 * @rule-checker exclude
 * @returns {*|void|boolean|{select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}|{findAllByOrderId(*): {select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}}|null}
 */
export default function () {
    const {findAllBy} = useApi();
    const state = useSelector;
    const newInstance = data => new OrderItem(data);
    const demo = useEmergencyInterventionDemo();

    return {
        findAllByOrderId(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.filter(oi => oi?.getOrderId() == id && oi?.isEnabled()));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "order_id", id);
                    }

                    findAllBy(SERVICE, ENTITY, "order_id", id, newInstance, "application_v7");
                }
            }
        }
    }
}